import { ApiGatewayError } from './api-gateway.error';
import { fuzzyKeyLookup } from '@shared/utilities/fuzzyKeyLookup';

export class ApiValidationError extends ApiGatewayError {
  override get details() {
    return {
      record: this.record,
      field: this.scope,
      value: fuzzyKeyLookup(this.record, this.scope),
    };
  }

  override buildInstance(): ApiGatewayError {
    try {
      const baseError = (this.cause as any).networkError.result.errors[0].extensions;
      this.key = baseError.code;
      this.scope = JSON.parse(baseError.details).error.field;
      return this;
    } catch {
      return new ApiGatewayError(this.messageService, this.cause);
    }
  }
}
